<script>
import messages from "../../mixins/messages";
import toasts from "../../mixins/toasts";
import Container from "./Container.vue";

export default Container.extend({
  mixins: [messages, toasts],
  methods: {
    create() {
      let loading = this.$loading.open();

      // let survey = {
      //   is_quiz: this.isQuiz,
      // };

      // survey.title = survey.is_quiz ? "Новый тест" : "Новая анкета";

      axios
        .post("/api/news/create")
        .then(({ data: article }) => {
          window.open(`/news/${article.id}/edit`, "_self");
        })
        .catch((error) => {
          loading.close();
          this.toast("error", "@unexpected", error);
        });
    },
  },
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/news/Index.vue